<form>
  <div class="content-card">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div class="header-wrapper">
        <h3 class="content-card__header">{{ 'WF-PersonalData' | translate }}</h3>
        <mat-icon class="icon" (click)="goToSelectedStep(questionnaireProcessStep.PersonalData)">create</mat-icon>
      </div>
    </div>

    <table>
      <tbody>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'FullName' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.FullName }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'Citizenship' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.Citizenship }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'DateOfBirth' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.DateOfBirth }}</td>
        </tr>
        @if (requirePlaceOfBirth) {
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'PlaceOfBirth' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.PlaceOfBirth }}</td>
        </tr>
        }
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'Pesel' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.Pesel }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'IdentityDocument' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.DocumentInfo }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'Email' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.Email }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'PhoneNumber' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.PhoneNumber }}</td>
        </tr>
        @if (workerFormSummary?.IsDriver) {
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'DriverLicenceCountry' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.DriverLicenceCountry }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'DriverLicenceNumber' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.DriverLicenceNumber }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'DriverLicenceExpirationDate' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.DriverLicenceExpirationDate | date : 'dd.MM.yyyy' }}
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="content-card">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div class="header-wrapper">
        <h3 class="content-card__header">{{ 'WF-AdressData' | translate }}</h3>
        <mat-icon class="icon" (click)="goToSelectedStep(questionnaireProcessStep.AddressData)">create</mat-icon>
      </div>
    </div>
    <table>
      <tbody>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'WF-Address' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.Address }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'WF-CorrespondenceAddress' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.CorrespondenceAddress }}</td>
        </tr>
        @if (workerFormSummary?.RegisteredAddress) {
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'WF-RegisteredAddress' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.RegisteredAddress }}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="content-card">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div class="header-wrapper">
        <h3 class="content-card__header">{{ 'WF-AdditionalData' | translate }}</h3>
        <mat-icon class="icon" (click)="goToSelectedStep(questionnaireProcessStep.AdditionalData)">create</mat-icon>
      </div>
    </div>
    <table>
      <tbody>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'WF-NationalHealthFund' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.NationalHealthFundName }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'WF-TaxOffice' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.TaxOfficeName }}</td>
        </tr>
        @if (showBankAccountNumber) {
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'WF-BankAccountNumber' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.BankAccountNumber | bankAccountFormat }}</td>
        </tr>
        }
      </tbody>
    </table>
    @if (emergencyContactSummary) {
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div class="header-wrapper">
        <h3 class="content-card__header" id="emergencyContact">{{ 'WF-EmergencyContact' | translate }}</h3>
      </div>
    </div>
    }

    @if (emergencyContactSummary) {
    <table>
      <tbody>
        @if (workerFormSummary?.EmergencyContactFirstName) {
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'WF-EmergencyContactFirstName' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.EmergencyContactFirstName }}</td>
        </tr>
        }
        @if (workerFormSummary?.EmergencyContactLastName) {
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'WF-EmergencyContactLastName' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.EmergencyContactLastName }}</td>
        </tr>
        }
        @if (workerFormSummary?.EmergencyContactPhone) {
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'WF-EmergencyContactPhone' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.EmergencyContactPhone }}</td>
        </tr>
        }
        @if (workerFormSummary?.EmergencyContactAddress) {
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'WF-EmergencyContactAddress' | translate }}</td>
          <td class="key-value-row__value">{{ workerFormSummary?.EmergencyContactAddress }}</td>
        </tr>
        }
      </tbody>
    </table>
    }

    @if (workerFormSummary?.HrNumbers && workerFormSummary.HrNumbers.length > 0) {
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div class="header-wrapper">
        <h3 class="content-card__header">{{ 'WF-HrNumberSection' | translate }}</h3>
      </div>
    </div>
    }

    @if (!isSelfWorkerForm && workerFormSummary?.HrNumbers && workerFormSummary.HrNumbers.length > 0) {
    <table>
      <tbody>
        @for (hrNumber of workerFormSummary.HrNumbers; track hrNumber) {
        <tr class="key-value-row">
          <td class="key-value-row__value">{{ hrNumber.HrNumber }}</td>
        </tr>
        }
      </tbody>
    </table>
    }
  </div>

  @if (!!statementsSummary) {
  <div class="content-card">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div class="header-wrapper">
        <h3 class="content-card__header">{{ 'WF-Statements' | translate }}</h3>
        <mat-icon class="icon" (click)="goToSelectedStep(questionnaireProcessStep.Statements)">create</mat-icon>
      </div>
    </div>
    @for (statementFormTypeId of statementFormTypeIds; track statementFormTypeId) {
    @if (statementsSummary[statementFormTypeId]; as statemens) {
    <table class="statements-table mb-3">
      <thead>
        <tr>
          <th>{{ titlesMap.get(+statementFormTypeId) | translate }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (statement of statemens; track statement) {
        <tr>
          <td [innerHtml]="statement.QuestionText | safeHtml"></td>
        </tr>
        <tr>
          <td class="answer-row">
            @if (statement.BooleanAnswer && statement.IsQuestionDocumentType && !statement.IsDocumentIncluded) {
            <span class="icon">
              <mat-icon>error</mat-icon>
            </span>
            }
            @if (statement.BooleanAnswer && statement.IsQuestionDocumentType && statement.IsDocumentIncluded) {
            <span class="icon">
              <mat-icon>check</mat-icon>
            </span>
            }
            @if (statement.AnswerText) {
            <span class="uppercase">{{ statement.AnswerText
              }}</span>
            } @else {
            @if (statement.BooleanAnswer) {
            <span class="uppercase">{{ 'WF-StatementSummaryTableYesHeader' |
              translate }}</span>
            }
            @if (!statement.BooleanAnswer) {
            <span class="uppercase">{{ 'WF-StatementSummaryTableNoHeader' |
              translate }}</span>
            }
            }
          </td>
        </tr>
        <tr>
          <td>
            <mat-divider></mat-divider>
          </td>
        </tr>
        <tr></tr>
        }
      </tbody>
    </table>
    }
    }
  </div>
  }

  @if ((listOfConsentTypes$ | async)?.length > 0) {
  <div class="content-card">
    @for (consentType of listOfConsentTypes$ | async; track consentType) {
    <form fxLayout="column" fxLayoutGap="10px" [formGroup]="consentsFormGroup">
      <!-- Consent -->
      @if (consentsFormGroup.controls['consent_' + consentType.Id]) {
      <div class="checkbox-value" fxLayout="row" fxLayoutGap="10px">
        <mat-checkbox [formControlName]="'consent_' + consentType.Id" (change)="toggleConsent($event, consentType.Id)"
          #cc></mat-checkbox>
        <label [class.required-consent]="!cc.checked && consentType.IsRequired">
          @if (isConsentExpanded(consentType.Id)) {
          <span>{{ consentType.Name | translate }}</span>
          }
          @if (!isConsentExpanded(consentType.Id)) {
          <span>{{ consentType.Name | translate | slice : 0 : 100 }}</span>
          }
        </label>
        <div class="toggler" (click)="toggleLabel(consentType.Id)">
          @if (isConsentExpanded(consentType.Id)) {
          <mat-icon class="icon">expand_less</mat-icon>
          }
          @if (!isConsentExpanded(consentType.Id)) {
          <mat-icon class="icon">expand_more</mat-icon>
          }
        </div>
      </div>
      }
    </form>
    }
    <!-- RODO -->
    @for (clause of clauses$ | async; track clause) {
    <div>
      <a [href]="clause.File" target="_blank" rel="noopener noreferrer">{{ clause.Name }}</a>
    </div>
    }
  </div>
  }
  <div>
    <div class="header-wrapper"></div>

    @if (!isWorkerFormApproved()) {
    <alert message="CheckPersonalDataAlert" alertType="info"></alert>
    }

    <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-10">
      <button mat-raised-button color="accent" matStepperPrevious>
        <mat-icon>arrow_back</mat-icon>
        {{ 'Back' | translate }}
      </button>
      @if (!isWorkerFormApproved()) {
      <button mat-raised-button color="primary" [disabled]="!isSubmitButtonEnabled()" (click)="onSubmit()">
        {{ 'Save' | translate }}
      </button>
      }
    </div>
  </div>
</form>